import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, selectToken } from "../login/loginSlice";
import { useNavigate } from "react-router-dom";

import './Home.css';

import Sidebar from "../../components/sidebar/Sidebar";
import AccountList from "../../components/accountList/AccountList";
import AdminActions from "../../components/adminActions/AdminActions";
import { loadUser, selectUser } from "./userSlice";

export default function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loggedIn = useSelector(isLoggedIn);
    const userInfo = useSelector(selectUser);
    const token = useSelector(selectToken);

    const username = userInfo.username;
    const userRole = userInfo.userRole;

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (!userRole && token && username) {
            dispatch(loadUser({token, username}))
        }
    }, [userRole, dispatch, token, username])

    return (
        <main>
            <Sidebar />
            {userRole === 'USER' ? <AccountList /> : <AdminActions />}
        </main>
    )
}